// rAF raced against a short timeout so hidden tabs (where rAF is paused) still progress — automated exports run with the browser backgrounded
export const raceFrame = (cb: () => void): (() => void) => {
	let raf = 0;
	let timer: ReturnType<typeof setTimeout> | null = null;
	let done = false;
	const run = (): void => {
		if (done) return;
		done = true;
		cancelAnimationFrame(raf);
		if (timer) clearTimeout(timer);
		cb();
	};
	raf = requestAnimationFrame(run);
	timer = setTimeout(run, 50);
	return (): void => {
		done = true;
		cancelAnimationFrame(raf);
		if (timer) clearTimeout(timer);
	};
};
